import React from "react";

export default function MembersMobile({
  loading,
  members,
  getLevel,
  navigate,
}) {
  return (
    <div className="lg:hidden space-y-4">
      {loading ? (
        <div className="bg-white rounded-2xl shadow p-8 text-center">
          Chargement...
        </div>
      ) : members.length === 0 ? (
        <div className="bg-white rounded-2xl shadow p-8 text-center text-gray-500">
          Aucun membre trouvé.
        </div>
      ) : (
        members.map((m) => (
          <div
            key={m.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100"
          >
            <div className="p-5">
              <div className="flex items-center gap-4">
                {m.avatar ? (
                  <img
                    src={m.avatar}
                    alt=""
                    className="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                  />
                ) : (
                  <div className="w-16 h-16 rounded-full bg-blue-600 text-white flex items-center justify-center text-2xl font-bold">
                    {m.prenom?.charAt(0).toUpperCase()}
                  </div>
                )}

                <div className="flex-1">
                  <h2 className="font-bold text-lg">
                    {m.prenom} {m.nom}
                  </h2>

                  <p className="text-xs text-gray-500 break-all">
                    {m.member_id}
                  </p>

                  <p className="text-sm text-gray-500 break-all">{m.email}</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 mt-5">
                <div className="bg-blue-50 rounded-xl p-3">
                  <p className="text-xs text-gray-500">Niveau</p>

                  <span
                    className={`inline-block mt-2 px-3 py-1 rounded-full text-white text-sm font-semibold
                    ${
                      getLevel(m.points || 0) === "Elite"
                        ? "bg-purple-600"
                        : getLevel(m.points || 0) === "Gold"
                          ? "bg-yellow-500"
                          : getLevel(m.points || 0) === "Silver"
                            ? "bg-gray-500"
                            : "bg-amber-700"
                    }`}
                  >
                    {getLevel(m.points || 0)}
                  </span>
                </div>

                <div className="bg-yellow-50 rounded-xl p-3">
                  <p className="text-xs text-gray-500">Points</p>

                  <h2 className="text-2xl font-bold text-blue-700 mt-1">
                    {m.points || 0}
                  </h2>
                </div>
              </div>
              <div className="col-span-2 flex items-center justify-between mt-2">
                <span
                  className={`px-3 py-1 rounded-full text-sm font-semibold ${
                    m.status === "suspended"
                      ? "bg-orange-100 text-orange-700"
                      : "bg-green-100 text-green-700"
                  }`}
                >
                  {m.status === "suspended" ? "Suspendu" : "Actif"}
                </span>

                <button
                  onClick={() => navigate(`/admin/member-details/${m.id}`)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-xl font-semibold transition"
                >
                  👁 Détails
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
